<template>
  <div class="basic-info-view">
    <el-form ref="basicInfo" :rules="rules" :model="queryParams">
      <div class="basic-info-block">
        <el-form-item label="产品类别编号：" prop="categoryCode" label-width="190px">
          <el-input
            style="width: 700px"
            v-model="queryParams.categoryCode"
            disabled
          />
        </el-form-item>

        <el-form-item label="产品类别名称：" prop="categoryName" label-width="190px">
          <el-input v-model="queryParams.categoryName" style="width: 700px" placeholder="请输入产品类别名称" />
        </el-form-item>

        <el-form-item label="产品类别类型：" prop="categoryTypeList" label-width="190px">
          <SelectTreeRadio
            :isTree="true"
            apiName="getDicRadioButton"
            :params="{ code: '021' }"
            resultType="values"
            vFeild="codeId"
            lFeild="codeName"
            storageKey="technicalCategory"
            v-model="queryParams.categoryTypeList"
            :isRadioFirstLevel="false"
            :isCheckBoxButton="false"
          ></SelectTreeRadio>
        </el-form-item>

        <el-form-item label="产品类别描述：" prop="description" label-width="190px">
          <Editorbar v-model="queryParams.description"></Editorbar>
        </el-form-item>

        <el-form-item label="产品类别价值描述：" prop="valueDescription" label-width="190px">
          <Editorbar v-model="queryParams.valueDescription"></Editorbar>
        </el-form-item>

      </div>
    </el-form>
  </div>
</template>

<script>
// components
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
import Editorbar from "@/components/Editorbar";
// api
import { getBasicInfo, updateBasicInfo, addBasicInfo } from "@/api/productClassify.js";

export default {
  components: {
    Editorbar,
    SelectTreeRadio
  },
  data() {
    //这里存放数据
    return {
      rules: {
        categoryName: [
          { required: true, message: "请输入产品类别名称", trigger: "blur" }
        ],
        categoryTypeList: [
          { required: true, message: "请选择产品类别类型", trigger: "blur" }
        ]
      },
      isInit: false,
      queryParams: {
        categoryCode: "", // 产品类别编号
        categoryName: "", // 产品类别名称
        categoryTypeList: "", // 产品类别类型list
        description: "", // 产品类别描述
        valueDescription: "" // 价值描述
      }
    };
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return void 0;
      }

      getBasicInfo({ id: this.$route.query.productCode }).then(res => {
        if (res.code == 200 && res.data) {
          this.isInit = true;
          this.queryParams = res.data;
        }
      });
    },
    submit() {
      this.$modal.loading('正在保存数据，请稍候...');

      updateBasicInfo(this.queryParams).then(res => {
        if(res.code === 200) {
          this.$message.success("编辑成功");
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$modal.closeLoading();
      });
    },
    saveBasicInfo() {
      this.$refs.basicInfo.validate((valid) => {
        if (valid) {
          addBasicInfo(this.queryParams).then(res => {
            if(res.code === 200) {
              this.$message.success("新增成功");
            } else {
              this.$message.error("新增失败!");
              return;
            }
            console.log("-----------", res.data)
            this.$emit("echoCategoryId", res.data);
            this.queryParams.categoryCode = res.data;
          }).finally(() => {
            this.$modal.closeLoading();
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
/deep/.el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.basic-info-view {
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item .Editorbar {
    width: 100%;
  }
}
</style>
